import React, { useState } from 'react';
import { Alert, Box, Button, Divider, HStack, Text, VStack } from '@chakra-ui/react';
import { FcGoogle } from 'react-icons/fc';
import { FaGithub } from 'react-icons/fa';
import { authReturn, rememberAuthReturn } from '../client/authContinuation';
import { authPost, useAuthProviders } from './socialAuth';

export const providerName = provider => provider === 'google' ? 'Google' : 'GitHub';

export default function ProviderButtons({ intent = 'signin', returnTo, connected = [], onError, divider = true, inset = false }) {
  const config = useAuthProviders();
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');
  const exclude = new URLSearchParams(window.location.search).get('linking');
  const providers = config.providers.filter(provider => !connected.includes(provider) && provider !== exclude);
  if (!providers.length) return null;

  const start = async provider => {
    setBusy(provider); setError('');
    try {
      if (config.canonical_origin?.startsWith('https://') && window.location.origin !== config.canonical_origin) {
        window.location.assign(config.canonical_origin + window.location.pathname + window.location.search);
        return;
      }
      const target = rememberAuthReturn(returnTo || authReturn());
      const data = await authPost(`${provider}/start`, { return_to: target, intent }, intent === 'link' ? localStorage.getItem('token') : null);
      window.location.assign(data.redirect_to);
    } catch (failure) {
      setBusy(''); setError(failure.message); onError?.(failure);
    }
  };

  return (
    <Box px={inset ? '5%' : 0} pt={inset ? '5%' : 0}>
      <VStack spacing={3} align="stretch">
        {providers.map(provider => (
          <Button key={provider} type="button" className="auth-provider-button" variant="outline" bg="white" color="gray.800"
            borderColor="gray.300" borderRadius="8px" minH="48px" width="100%" fontWeight="500"
            leftIcon={provider === 'google' ? <FcGoogle size={20} aria-hidden="true" /> : <FaGithub size={20} aria-hidden="true" />}
            _hover={{ bg: 'gray.50', borderColor: 'gray.400' }} _focusVisible={{ boxShadow: 'outline' }}
            isLoading={busy === provider} isDisabled={Boolean(busy)} loadingText="Connecting…" onClick={() => start(provider)}>
            {intent === 'link' ? 'Connect' : 'Continue with'} {providerName(provider)}
          </Button>
        ))}
      </VStack>
      {error && <Alert status="error" mt={3} fontSize="sm" role="alert">{error}</Alert>}
      {divider && <HStack spacing={4} mt={5} mb={1}><Divider borderColor="gray.300" /><Text fontSize="sm" color="gray.600">or</Text><Divider borderColor="gray.300" /></HStack>}
    </Box>
  );
}
